export enum TopicChannelThreadContinuationState {
  ContinuationEnabled = "continuation_enabled",
  ContextOnly = "context_only",
  Detached = "detached",
}
